// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import { Tabs, itemList } from "@lifepay/rc-ui-toolkit";
import { startOfYesterday, endOfToday } from "date-fns";
// import Input from "@lifepay/rc-ui-toolkit/dist-modules/controls/Input";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
// import actions from "model/actions";
import selectors from "model/selectors";

// import Terminals from "../acquiring/Terminals";
// import Transactions from "../acquiring/Transactions";

import Merchant, { MerchantHeader } from "components/list-items/Merchant";
import Terminal, { TerminalHeader } from "components/list-items/Terminal";
import Transaction, {
  TransactionHeader,
} from "components/list-items/Transaction";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./Acquiring.m.scss";

import { merchants, terminals, terminalTransactions } from "model/gql/queries";
const MerchantsData = itemList.QueryFactory(merchants);
const TerminalsData = itemList.QueryFactory(terminals);
const TransactionsData = itemList.QueryFactory(terminalTransactions);

// RELATIVE PATH IMPORTS
// importing default component styles

@withRouter
// connecting component to the redux store
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      selectedCompany: selectors.clients.selectedCompany$$(state),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {}
)
@themr("client-search", styles)
export default class Acquiring extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object, // object with css class names
    history: PropTypes.object,
    match: PropTypes.object,
    basePath: PropTypes.string,
    location: PropTypes.object,
    selectedCompany: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      merchantsSkip: true,
      merchantsFilter: {},
      terminalsSkip: true,
      terminalsFilter: {},
      transactionsSkip: true,
      transactionsFilter: {},
    };
  }

  saveSkipState = ({ id, value }) => {
    this.setState({ [`${id}Skip`]: value });
  };

  saveLastFilter = ({ id, value }) => {
    this.setState({ [`${id}Filter`]: value });
  };

  render() {
    const { theme, history, match, selectedCompany, basePath } = this.props;
    // const {
    //   merchantsSkip,
    //   merchantsFilter,
    //   terminalsSkip,
    //   terminalsFilter,
    //   transactionsSkip,
    //   transactionsFilter,
    // } = this.state;
    const route = match.params.subdir;
    let activeTab = null;
    switch (route) {
      case "merchants": {
        activeTab = "MERCHANTS";
        break;
      }
      case "terminals": {
        activeTab = "TERMINALS";
        break;
      }
      case "transactions": {
        activeTab = "TRANSACTIONS";
        break;
      }
      default: {
        activeTab = "MERCHANTS";
      }
    }
    return selectedCompany && selectedCompany.type === "COMPANY" ? (
      <div className={classnames(theme.wrapper)}>
        <Tabs
          activeTab={activeTab}
          tabs={[
            {
              id: "MERCHANTS",
              component: "Точки обслуживания",
              onClick: () => {
                history.push(`${basePath}/merchants`);
              },
            },
            {
              id: "TERMINALS",
              component: "Терминалы",
              onClick: () => {
                history.push(`${basePath}/terminals`);
              },
            },
            {
              id: "TRANSACTIONS",
              component: "Транзакции",
              onClick: () => {
                history.push(`${basePath}/transactions`);
              },
            },
          ]}
        >
          {({ activeTab }) => {
            switch (activeTab) {
              case "MERCHANTS": {
                return (
                  <itemList.List
                    key={"MERCHANTS"}
                    useDataComponent
                    history={history}
                    location={location}
                    dataComponent={MerchantsData}
                    filtersConfig={[
                      {
                        key: "companyId",
                        label: "Id компании",
                        type: "const",
                        default: selectedCompany
                          ? selectedCompany.remoteId
                          : null,
                      },
                      {
                        key: "merchantIds",
                        label: "Id точек обслуживания",
                        type: "multi-value",
                      },
                      {
                        key: "merchantName",
                        label: "Наименование точки обслуживания",
                        type: "string",
                      },
                    ]}
                  >
                    {(listProps) => (
                      <React.Fragment>
                        <itemList.Controls {...listProps} />
                        <itemList.Results
                          {...listProps}
                          usePaginator={true}
                          Header={MerchantHeader}
                          Item={Merchant}
                          ItemProps={{
                            basePath,
                          }}
                        />
                      </React.Fragment>
                    )}
                  </itemList.List>
                );
              }
              case "TERMINALS": {
                return (
                  <itemList.List
                    key={"TERMINALS"}
                    useDataComponent
                    history={history}
                    location={location}
                    dataComponent={TerminalsData}
                    filtersConfig={[
                      {
                        key: "companyId",
                        label: "Id компании",
                        type: "const",
                        default: selectedCompany
                          ? selectedCompany.remoteId
                          : null,
                      },
                      {
                        key: "merchantId",
                        label: "Id точки обслуживания",
                        type: "string",
                      },
                      {
                        key: "terminalIds",
                        label: "Id терминалов (маска по символу %)",
                        type: "multi-value",
                      },
                    ]}
                  >
                    {(listProps) => (
                      <React.Fragment>
                        <itemList.Controls {...listProps} />
                        <itemList.Results
                          {...listProps}
                          usePaginator={true}
                          Header={TerminalHeader}
                          Item={Terminal}
                          ItemProps={{
                            basePath,
                          }}
                        />
                      </React.Fragment>
                    )}
                  </itemList.List>
                );
              }
              case "TRANSACTIONS": {
                return (
                  <itemList.List
                    key={"TRANSACTIONS"}
                    useDataComponent
                    history={history}
                    location={location}
                    dataComponent={TransactionsData}
                    loadInitially={false}
                    filtersConfig={[
                      {
                        key: "companyId",
                        label: "Id компании",
                        type: "const",
                        default: selectedCompany
                          ? selectedCompany.remoteId
                          : null,
                      },
                      {
                        key: "sortById",
                        label: "Сортировать по id",
                        type: "select",
                        hidden: true,
                        options: {
                          placeholder: "По умолчанию",
                          chooseAllName: "По умолчанию",
                          options: [
                            { value: "ASC", label: "По возрастанию" },
                            { value: "DSC", label: "По убыванию" },
                          ],
                        },
                      },
                      {
                        key: "sortByDate",
                        label: "Сортировать по дате",
                        type: "select",
                        hidden: true,
                        options: {
                          placeholder: "По умолчанию",
                          chooseAllName: "По умолчанию",
                          options: [
                            { value: "ASC", label: "Самые старые" },
                            { value: "DSC", label: "Самые новые" },
                          ],
                        },
                      },
                      {
                        key: "dates",
                        type: "date-range",
                        default: {
                          startDate: startOfYesterday(),
                          endDate: endOfToday(),
                        },
                        required: true,
                        requiredMessage: "Введите даты",
                      },
                      {
                        key: "isSuccessful",
                        label: "Статус",
                        type: "select",
                        numeric: true,
                        options: {
                          placeholder: "Все",
                          chooseAllName: "Все",
                          options: [
                            { value: 0, label: "Только неуспешные" },
                            { value: 1, label: "Только успешные" },
                          ],
                        },
                      },
                      {
                        key: "transactionType",
                        label: "Тип транзакции",
                        type: "select",
                        numeric: true,
                        options: {
                          placeholder: "По всем типам",
                          chooseAllName: "По всем типам",
                          options: [
                            { value: 0, label: "Отмены" },
                            { value: 1, label: "Оплаты" },
                            { value: 2, label: "Возвраты" },
                            {
                              value: 3,
                              label: "Выдача",
                            },
                            {
                              value: 4,
                              label: "p2p",
                            },
                          ],
                        },
                      },
                      {
                        key: "originType",
                        label: "Источник транзакции",
                        type: "select",
                        options: {
                          placeholder: "По всем типам",
                          chooseAllName: "По всем типам",
                          options: [
                            { value: 1, label: "Наша карта в нашем устр." },
                            { value: 2, label: "Чужая карта в нашем устр." },
                            { value: 3, label: "Наша карта в чужом устр." },
                            {
                              value: 4,
                              label: "Чужая карта в чужом устр.",
                            },
                          ],
                        },
                      },
                      {
                        key: "merchantId",
                        label: "Id точки обслуживания",
                        type: "string",
                      },
                      {
                        key: "terminalId",
                        label: "Id терминала",
                        type: "string",
                      },
                      {
                        key: "transactionId",
                        label: "Id транзакции",
                        type: "string",
                      },
                      {
                        key: "pan",
                        label: "PAN (4 цифры / маска по символу %)",
                        type: "string",
                        required: true,
                        // not set or more than 4 digits
                        isValid: (value) =>
                          !value || value.replace(/\D+/g, "").length >= 4,
                        requiredMessage: "PAN должен содержать не менее 4 цифр",
                        // keep only digits and %
                        inputFormatter: (value) =>
                          value.replace(/[^0-9%]/g, ""),
                      },
                      {
                        key: "authcode",
                        label: "Код авторизации",
                        type: "string",
                      },
                      {
                        key: "rrn",
                        label: "RRN",
                        type: "string",
                      },
                    ]}
                  >
                    {(listProps) => (
                      <React.Fragment>
                        <itemList.Controls {...listProps} />
                        <itemList.Results
                          {...listProps}
                          usePaginator={true}
                          Header={TransactionHeader}
                          Item={Transaction}
                        />
                      </React.Fragment>
                    )}
                  </itemList.List>
                );
              }
            }
          }}
        </Tabs>
      </div>
    ) : (
      <Redirect to={`/client/search`} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/Acquiring/Acquiring.js